import {
  ADD_SKU,
  EDIT_SKU,
  REMOVE_SKU,
  SET_CODE,
  SET_DESCRIPTION,
  SET_END_DATE,
  SET_NAME,
  SET_PRODUCT_LINE_CODE,
  SET_SKU,
  SET_SP_CODE,
  initialState,
} from "./constants";
import { ActionTypes, IState } from "./types";

function reducer(state: IState, action: ActionTypes) {
  switch (action.type) {
    case SET_NAME:
      return { ...state, name: action.payload };
    case SET_CODE:
      return { ...state, code: action.payload };
    case SET_PRODUCT_LINE_CODE:
      return {
        ...state,
        productLineCode: action.payload,
        skus: initialState.skus,
      };
    case SET_SP_CODE:
      return {
        ...state,
        spCode: action.payload,
        skus: initialState.skus,
      };
    case SET_END_DATE:
      return { ...state, endDate: action.payload };
    case SET_DESCRIPTION:
      return { ...state, description: action.payload };
    case SET_SKU:
      return { ...state, skus: action.payload };
    case ADD_SKU:
      return { ...state, skus: [...state.skus, { rank: state.skus.length }] };
    case EDIT_SKU: {
      const { rank, id } = action.payload;
      const updatedSKU = { ...state.skus[rank], id };
      const skus = [...state.skus];
      skus.splice(rank, 1, updatedSKU);
      return { ...state, skus };
    }
    case REMOVE_SKU: {
      const skus = [...state.skus];
      skus.pop();
      return { ...state, skus };
    }
    default:
      return { ...state };
  }
}

export default reducer;
